export default __webpack_public_path__ + "static/media/green-vaccine.db90b706.svg";